// extracted by mini-css-extract-plugin
export default {"root":"HeroLoadSpinner_root__hgtoe"};